import React from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { graphql, useStaticQuery } from 'gatsby';

const CounterHook = ({ change, end }) => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        counter {
          id
          count
          counter_title
        }
      }
    }
  `);

  const {
    strapiHomePage: { counter },
  } = data;

  return (
    <>
      {counter.map((node) => {
        const count = node.count;
        return (
          <div
            className='col-lg-3 col-md-6 col-sm-12 wow fadeInUp'
            data-wow-duration='1500ms'
            key={node.id}
            style={{ display: 'flex' }}
          >
            <div className='fact-one__single' style={{ float: 'left' }}>
              <div className='fact-one__inner'>
                <h3 className='fact-one__count counter'>
                  <VisibilitySensor
                    onChange={change}
                    offset={{ top: 10 }}
                    delayedCall
                  >
                    <CountUp end={end ? `${count}` : 0} />
                  </VisibilitySensor>
                </h3>
                <p className='fact-one__text'>{node.counter_title}</p>
              </div>
            </div>
            {count < counter.length && (
              <div style={{ marginTop: '100px', marginLeft: '10px' }}>
                <i
                  className='dimon-icon-right-arrow'
                  style={{ fontSize: '40px' }}
                ></i>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default CounterHook;
